import { isDenebEnabled } from '@/const/flags'

import { useSession as useAltairSession } from './session.altair'
import { useSession as useDenebSession } from './session.deneb'

export const useSession = isDenebEnabled ? useDenebSession : useAltairSession
